// IMPORT BASE-MODULE
import BaseModule from "@core/modules/base-module/base-module";
import TeaserSlider from "@pj/components/snap-sliders/teasers-snap-slider/teasers-snap-slider";
import Pattern from "@pj/components/pattern/pattern";
import $ from "jquery";
import Utils from "@core/base/scripts/utils/utils";

const viewMoreModule = new BaseModule();
viewMoreModule.name = "view-more-teaser";
viewMoreModule.init(that => {
  const sliders = [];
  $(that.elements).each(function() {
    const slider = new TeaserSlider();
    sliders.push(slider);
    slider.init(this);
    const pattern = new Pattern();
    pattern.init(this);
  });
  viewMoreModule.onResize(() => {
    sliders.forEach(sliderItem => {
      sliderItem.onResize();
    });
  });
});

viewMoreModule.onResize(that => {
  $(that.elements).each(function() {
    resize(this);
  });
});

function resize(el) {
  const $bg = $(el).find(".view-more-teaser__bg");
  const $pattern = $(el).find(
    ".view-more-teaser--blue .view-more-teaser__pattern"
  );
  const $cols = $(el).find(".teaser-card__image-col");

  if ($cols && $cols.length > 0) {
    const colsHeight = $cols.height();
    $bg.css({
      top: colsHeight
    });
    //
    $pattern.css({
      top: colsHeight
    });
  }
  // resize items only for "full" mode
  const isFull = $(el).find(".view-more-teaser--full").length > 0;
  if (isFull && !Utils.isMobile) {
    resizeItems($(".teaser-card", $(el)));
  }
}

function resizeItems(items) {
  items.removeAttr("style");
  const maxHeight = Math.max.apply(
    null,
    items
      .map(function() {
        return $(this).height();
      })
      .get()
  );
  items.height(maxHeight);
}
